import dayjs from 'dayjs';

export const formatDateRange = ({ startDate, endDate }: { startDate: string; endDate: string }): string => {
  if (startDate === endDate) {
    return dayjs(startDate).format('D MMMM');
  }

  if (dayjs(startDate).isSame(endDate, 'month')) {
    return `${dayjs(startDate).format('D')}-${dayjs(endDate).format('D')} ${dayjs(endDate).format('MMMM')}`;
  }

  return `${dayjs(startDate).format('D MMMM')} - ${dayjs(endDate).format('D MMMM')}`;
};

export const formatDateRangeFull = ({ startDate, endDate }: { startDate: string; endDate: string }): string => {
  const start = dayjs(startDate);
  const end = dayjs(endDate);

  return `${start.format('MMM D, YYYY')}–${end.format('MMM D, YYYY')}`;
};
